import "./BillingPageHeader.css";

const BillingPageHeader = ({
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <section className="billing-page-header">
    <div className="billing-page-header__copy">
      <h2 className="billing-page-header__title">{title}</h2>
      {description ? (
        <p className="billing-page-header__description">{description}</p>
      ) : null}
    </div>

    {actionLabel ? (
      <button
        type="button"
        className="billing-page-header__action"
        onClick={onAction}
      >
        {actionLabel}
      </button>
    ) : null}
  </section>
);

export default BillingPageHeader;
